import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import { FindPharmacyDdAction } from '@/constants/ddActions/pharmacy';
import useNonBenefitMapNearByPharmacySearchTabs from '@/hooks/nonBenefit/useNonBenefitMapNearbyPharmacySearchTabs';
import { NearbyPharmacyFilterModel } from '@/models/pharmacy';
import { DiagnosisType } from '@/types/bff/gql-schema';
import { NearbyPharmacySortsVo, PharmacySearchQueries } from '@/types/pharmacy';
import { updateSearchParams } from '@/utils/url';
import useLogger from '../useLogger';

interface Tab {
  id: string;
  name: string;
  diagnosisType?: DiagnosisType | null;
  diagnosisTypeId?: string | null;
  sortTypes: Array<NearbyPharmacySortsVo>;
  filters: NearbyPharmacyFilterModel[];
}

const useNonBenefitMapCategoryTabs = () => {
  const router = useRouter();
  const { diagnosisTypeId } = router.query as PharmacySearchQueries;

  const { data: tabs } = useNonBenefitMapNearByPharmacySearchTabs();
  const [selectedTab, setSelectedTab] = useState<Tab | null>(null);

  const { log } = useLogger();

  const selectTab = (tab: Tab) => {
    setSelectedTab(tab);
    updateSearchParams([
      {
        key: 'diagnosisType',
        value: tab.diagnosisType ?? '',
      },
      {
        key: 'diagnosisTypeId',
        value: tab.diagnosisTypeId ?? '',
      },
      { key: 'treatmentMedicineId', value: '' },
      { key: 'treatmentMedicineUnitId', value: '' },
    ]);

    log({
      eventName: `${FindPharmacyDdAction.ClickTab}-${tab.id}`,
    });
  };

  useEffect(() => {
    if (!tabs) {
      return;
    }

    if (diagnosisTypeId) {
      const selectedTab = tabs.find((tab) => tab.diagnosisTypeId === diagnosisTypeId);
      if (selectedTab) {
        setSelectedTab(selectedTab);
        return;
      }
    }

    setSelectedTab(tabs?.[0]);
  }, [tabs, diagnosisTypeId]);

  return {
    tabs,
    selectedTab,
    selectTab,
  };
};

export default useNonBenefitMapCategoryTabs;
